import { bffApi } from "../../../../services/bff/bffApi";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import { BaseService } from "../../../../global/classes";
import { CreateCreditorPayload, CreditorFilterValues, UpdateCreditorPayload } from "../type";


export default class CreditorsService extends BaseService {
  async getCreditorsPaged(
    pageNumber: number,
    pageSize: number,
    filter?: CreditorFilterValues,
  ) {
    try {
      const response = await bffApi.get(
        `/api/reg/v1/creditor/paged`,
        {
          params: {
            pageNumber,
            pageSize,
            creditorDocument: filter?.documentNumber || undefined,
          },
        },
      );

      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.error(errorMessage);
      throw error;
    }
  }

  async createCreditor(payload: CreateCreditorPayload) {
    try {
      const response = await bffApi.post(
        `/api/reg/v1/creditor`,
        payload,
      );

      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.error(errorMessage);
      throw error;
    }
  }

  async updateCreditor(id: number, payload: UpdateCreditorPayload) {
    try {
      const response = await bffApi.patch(
        `/api/reg/v1/creditor`,
        payload,
        {
          params: { id },
        },
      );

      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.error(errorMessage);
      throw error;
    }
  }
}
